import type { ImageSource } from '../../../components/marketing/ResponsiveImage';

import heroPng from '../hero-rooftop.png';

/**
 * Hero raster for `social_visuals_v1`. Use `webp` + `fallback` for `<picture>`; PNG-only is OK
 * (`webp: []` — {@link import('../../../components/marketing/ResponsiveImage').ResponsiveImage}).
 */
export const HERO_CLUSTER_RASTER: {
  webp: ImageSource[];
  fallback: ImageSource[];
  /** Largest variant dimensions (LCP + CLS). */
  intrinsic: { w: number; h: number };
} | null = {
  webp: [],
  fallback: [{ src: heroPng, width: 1672 }],
  intrinsic: { w: 1672, h: 941 },
};

/** True when a raster is configured ({@link HeroMarketingVisual} otherwise uses `hero-circle-scene.svg`). */
export function hasHeroClusterRaster(): boolean {
  return !!(HERO_CLUSTER_RASTER && HERO_CLUSTER_RASTER.fallback.length > 0);
}
